/** True while the eraser tool is selected (idle, pointing, or mid-stroke). */
export function isEraserToolActive(editor) {
  if (!editor) return false;
  if (editor.getCurrentToolId?.() === 'eraser') return true;
  const path = editor.getPath?.() ?? '';
  return path.startsWith('eraser.');
}

/** True while the user is mid-stroke with draw / eraser / arrow tools. */
export function isCanvasStrokeInProgress(editor) {
  if (!editor) return false;
  const path = editor.getPath?.() ?? '';
  return (
    path === 'draw.drawing'
    || path === 'eraser.erasing'
    || path === 'arrow.pointing'
    // Arrow shape + bindings finalize while dragging, not only on initial point.
    || path === 'arrow.dragging'
  );
}
